<template>

  <div>
    <el-row :gutter="18" align="bottom">
      <el-col :sm="24" :md="10">
        <h2><i class="fa fa-share-alt">&nbsp;</i><org-badge /> {{ title }}</h2>
      </el-col>
    </el-row>

    <div style="padding-top: 1.2em">
      <el-tabs type="border-card" v-model="menu" @tab-click="onTabChange">

        <el-tab-pane name="report">
            <template #label><span><i class="fa fa-globe"></i> Summary</span></template>

            <el-tabs tab-position="right">
              <el-tab-pane>
                  <template #label><span><i class="fa fa-share-alt"></i> Requests Report</span></template>
                  <requests-report :sharer="telcoId" :stats="stats" />
              </el-tab-pane>

              <el-tab-pane name="stale-report" lazy>
                  <template #label><span><i class="fa fa-minus"></i> Stale Requests</span></template>

                  <stale-request-report />
              </el-tab-pane>

            </el-tabs>

        </el-tab-pane>


        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="acquire" lazy>
            <template #label><span><i class="fa fa-street-view"></i> Acquire&nbsp;<span v-if="stats.rta > 0" class="badge">&nbsp;{{stats.rta}}&nbsp;</span></span></template>

          <request-table type="RTA" heading="Acquire" :sharer="telcoId" :rejected="stats.rtaRejected" :active="stats.rta" :closed="stats.rtaClosed"  />
        </el-tab-pane>


        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="share" lazy>
            <template #label><span><i class="fa fa-share-alt"></i> New Shares&nbsp;<span v-if="stats.rts > 0" class="badge">&nbsp;{{stats.rts}}&nbsp;</span></span></template>

          <request-table type="RTS" heading="Share" :sharer="telcoId" :rejected="stats.rtsRejected" :active="stats.rts" :closed="stats.rtsClosed"  />
        </el-tab-pane>


        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="upgrade" lazy>
          <template #label><span><i class="fa fa-tools"></i> Upgrades&nbsp;<span v-if="stats.rtu > 0" class="badge">&nbsp;{{stats.rtu}}&nbsp;</span></span></template>

          <request-table type="RTU" heading="Upgrade" :sharer="telcoId" :rejected="stats.rtuRejected" :active="stats.rtu" :closed="stats.rtuClosed" />
        </el-tab-pane>


        <el-tab-pane v-if="(isTelco() || isBackhaulCo()) || canAccess('project|maintenance|finance|admin|management')" name="backhaul" lazy>
          <template #label><span><i class="fa fa-wifi"></i> Backhaul&nbsp;<span v-if="stats.rtb > 0" class="badge">&nbsp;{{stats.rtb}}&nbsp;</span></span></template>

          <request-table type="RTB" heading="Backhaul" :sharer="telcoId" :rejected="stats.rtbRejected" :active="stats.rtb" :closed="stats.rtbClosed" />
        </el-tab-pane>

        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="dismantle" lazy>
          <template #label><span><i class="fa fa-xmark"></i> Dismantle&nbsp;<span v-if="stats.rtd > 0" class="badge">&nbsp;{{stats.rtd}}&nbsp;</span></span></template>

          <request-table type="RTD" heading="Dismantle" :sharer="telcoId" :rejected="stats.rtdRejected" :active="stats.rtd" :closed="stats.rtdClosed" />
        </el-tab-pane>



        <el-tab-pane v-if="(isTelco() || isBackhaulCo()) || canAccess('project|maintenance|finance|admin|management')" name="calendar" lazy>
          <template #label><span><i class="fa fa-calendar"></i> Requests Calendar</span></template>

          <events-calendar category="requests" :sharer="telcoId" />

        </el-tab-pane>


      </el-tabs>
    </div>

    <drawer-stack :base-path="drawerBasePath" />

  </div>

</template>

<script>

import StaleRequestReport from '@/components/dashboard/requests/StaleRequestReport'
import RequestsReport from '@/components/dashboard/requests/RequestsReport'

import EventsCalendar from '@/components/atoms/EventsCalendar'

import RequestTable from '@/components/requests/RequestTable'
import DrawerStack from '@/components/atoms/layers/DrawerStack'

import { SLUG_TO_INTERNAL, INTERNAL_TO_SLUG } from '@/lib/requestTypeSlugs'

export default {

  components: {
    EventsCalendar,
    StaleRequestReport,
    RequestTable,
    RequestsReport,
    DrawerStack
  },


  computed: {
    drawerBasePath () {
      var slug = this.$route.params.typeSlug || 'summary'
      return '/requests/' + slug
    }
  },


  methods: {

    updateStats (stats) {
      this.stats = stats
    },

    onTabChange (tab) {
      var slug = INTERNAL_TO_SLUG[tab.name] || 'summary'
      // NavigationDuplicated guard — avoid pushing the same route
      if (this.$route.params.typeSlug === slug) return
      this.$router.push({
        params: { typeSlug: slug, drawerPath: undefined },
        query: this.$route.query
      })
    }

  },


  watch: {
    '$route': {
      handler: function (route) {
        var slug = route.params.typeSlug || 'summary'
        this.menu = SLUG_TO_INTERNAL[slug] || 'report'
        var qSharer = route.query.sharerId
        if (!this.isTelco() && qSharer) {
          this.telcoId = Number(qSharer)
          this.refreshStats(this.telcoId, this.updateStats)
        } else {
          this.telcoId = this.org().id
          this.refreshStats(null, this.updateStats)
        }
      },
      immediate: true
    }
  },



  data () {
    var slug = this.$route.params.typeSlug || 'summary'
    return {
      title: 'Requests',
      menu: SLUG_TO_INTERNAL[slug] || 'report',
      stats: this.getStats(),
      telcoId: (this.isTelco() ? this.org().id : (Number(this.$route.query.sharerId) || null))
    }
  }
}

</script>

<style scoped>
.badge {
     top:-10px;
     right:-10px;
     font-size:0.8em;
     padding: 0.2em;
     background: #DCDFE6;
     color:#303133;
     text-align:center;
     border-radius:30%;
     box-shadow:0 0 1px #333;
   }
</style>
